// extracted by mini-css-extract-plugin
export default {"table-bulk-action-container":"Z7GjCyWi","paginate-select":"IPrFq0MQ"};